import { render, staticRenderFns } from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=template&id=76cb3c2a&scoped=true&"
import script from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb3c2a",
  null
  
)

export default component.exports